import { statisticsWindow, type StatisticsPeriod } from './statistics'

export type JdOrderStatisticsPeriod = StatisticsPeriod | 'all'

export interface JdOrderStatisticsWindow {
  key: JdOrderStatisticsPeriod
  label: string
  startDate: string
  endDate: string
  dataStartDate: string
  dataEndDate: string
}

export function jdOrderStatisticsWindow(
  meta: { queryStart: string; queryEnd: string } | null | undefined,
  period: JdOrderStatisticsPeriod,
): JdOrderStatisticsWindow | null {
  if (!meta) return null
  if (period === 'all') return {
    key: 'all',
    label: '全部',
    startDate: meta.queryStart,
    endDate: meta.queryEnd,
    dataStartDate: meta.queryStart,
    dataEndDate: meta.queryEnd,
  }
  const window = statisticsWindow(period, meta.queryEnd, [])
  return {
    key: period,
    label: window.label,
    startDate: window.startDate,
    endDate: window.endDate,
    dataStartDate: meta.queryStart,
    dataEndDate: meta.queryEnd,
  }
}
